module.exports = __webpack_public_path__ + "img/bow.e3757ba4.svg";